import React from 'react';
import styles from './loader.module.scss';

const Loader = () => {
    return (
        // <div className={styles.ldDefault}>
        //     <div></div>
        // </div>
        <div className={styles.ldDefault}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

// const Loader = () => {
//     return (
//         <div className={styles.skeletonLayout}>
//             {/* Skeleton for summary column */}
//             <div className={`${styles.skeletonColumn} ${styles.summaryCol}`}>
//                 <div className={styles.skeletonHeader}></div>
//                 <div className={styles.skeletonContent}>
//                     <div className={styles.skeletonLine}></div>
//                     <div className={styles.skeletonLine}></div>
//                     <div className={styles.skeletonLine}></div>
//                 </div>
//                 <div className={styles.skeletonFooter}></div>
//             </div>
//             {/* Skeleton for payments column */}
//             <div className={`${styles.skeletonColumn} ${styles.paymentsCol}`}>
//                 <div className={styles.skeletonHeader}></div>
//                 <div className={styles.skeletonContent}>
//                     <div className={styles.skeletonLine}></div>
//                     <div className={styles.skeletonLine}></div>
//                     <div className={styles.skeletonLine}></div>
//                 </div>
//             </div>
//         </div>
//     );
// };

export default Loader;